import { useDemoState } from "@/data/demoState";
import { Badge } from "@/components/ui/badge";
import {
  HardHat, Briefcase, Wrench, Users, ClipboardCheck, Home, Gift, Eye
} from "lucide-react";

const lensIcons = {
  'builder-pm': HardHat,
  'office-admin': Briefcase,
  'site-supervisor': Wrench,
  'consultant': Users,
  'surveyor': ClipboardCheck,
  'client': Home,
  'buyer': Gift,
};

export default function RoleLensSelector({ compact = false }) {
  const { activeLens, setActiveLens, roleLenses } = useDemoState();

  if (compact) {
    return (
      <div className="flex items-center gap-1" data-testid="role-lens-compact">
        <Eye className="w-3 h-3 text-slate-400" />
        {roleLenses.map(l => {
          const Icon = lensIcons[l.id] || HardHat;
          const active = activeLens === l.id;
          return (
            <button key={l.id} onClick={() => setActiveLens(l.id)} data-testid={`lens-${l.id}`}
              className={`w-7 h-7 rounded-lg flex items-center justify-center transition-all ${active ? 'bg-blue-100 text-blue-600 ring-2 ring-blue-200' : 'bg-slate-100 text-slate-400 hover:bg-slate-200'}`}
              title={l.label}>
              <Icon className="w-3.5 h-3.5" />
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="role-lens-selector">
      <Eye className="w-3.5 h-3.5 text-slate-400 shrink-0" />
      <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider shrink-0">Lens:</span>
      {roleLenses.map(l => {
        const Icon = lensIcons[l.id] || HardHat;
        const active = activeLens === l.id;
        return (
          <button key={l.id} onClick={() => setActiveLens(l.id)} data-testid={`lens-${l.id}`}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-[10px] font-semibold transition-all ${active ? 'bg-blue-100 text-blue-700 ring-1 ring-blue-200' : 'bg-slate-50 text-slate-500 hover:bg-slate-100 border border-slate-200'}`}>
            <Icon className="w-3 h-3" />{l.label}
          </button>
        );
      })}
    </div>
  );
}
